export function normalizeNumber(number: number | undefined): number {
  return number ?? 0;
}
